import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/public-ids/$id/')({
  beforeLoad: ({
    params
  }) => {
    // デフォルトで詳細タブにリダイレクト
    throw redirect({
      to: '/public-ids/$id/details',
      params: {
        id: params.id
      }
    });
  }
});